export default __webpack_public_path__ + "static/media/3233 spice rack D side.80a9a36d.png";